import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ngx-email-validation',
    templateUrl: './email-validation.component.html',
    styleUrls: ['./email-validation.component.scss'],
    standalone: false
})
export class EmailValidationComponent implements OnInit {

  status: string | null = null;
  message: string | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.status = params['status'];
      this.message = params['message'];
    });
  }
}
